import { render, staticRenderFns } from "./Publishers.vue?vue&type=template&id=6bdd083a&scoped=true"
import script from "./Publishers.vue?vue&type=script&lang=js"
export * from "./Publishers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bdd083a",
  null
  
)

export default component.exports